import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { RuleEngineService } from '../../services/rule-engine.service';
import { Subscription } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  Rule,
  RuleExpressoins,
  RuleExpression,
} from '../models/rule-engine';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-expression-builder',
  templateUrl: './expression-builder.component.html',
  styleUrls: ['./expression-builder.component.scss'],
})
export class ExpressionBuilderComponent implements OnInit, OnDestroy {
  private _ruleServiceSubscription!: Subscription;
  private _ruleEngineService!: RuleEngineService;
  rules: Rule[] = [];
  countOfRules: number = 1;
  selectedRuleNumber: any = 'Rule Name';
  private _fb!: FormBuilder;
  expressionBuilderForm!: FormGroup;
  finalExpression!: string;
  invalidExpression!: string;

  constructor(
    private toastr: ToastrService,
    fb: FormBuilder,
    ruleEngineService: RuleEngineService,
    public dialogRef: MatDialogRef<ExpressionBuilderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._fb = fb;
    this._ruleEngineService = ruleEngineService;
  }

  choosenRule(selectedRuleNumber: any) {
  }

  ngOnInit(): void {
    this._ruleServiceSubscription = this._ruleEngineService.getAllRules().subscribe({
      next: (data) => {
        this.rules = data;
      },
      error: (err) => {this.toastr.error("Unable to get rules", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });}
    });

    this.initiateExpressoinBuilderForm();
    this.buildFinalExpression();
    let storedFormData = this._ruleEngineService.getTheBuilderExpressionData();
    if (storedFormData) {
      this.loadFormData(storedFormData);
    }
  }

  ngOnDestroy(): void {
    if (this._ruleServiceSubscription) {
      this._ruleServiceSubscription.unsubscribe();
    }
  }
  onClickClose() {
    this._ruleEngineService.setPopUpValueForExpressionBuilder(false);
    this.dialogRef.close();
  }

  initiateExpressoinBuilderForm() {
    this.expressionBuilderForm = this._fb.group({
      expressionGroupArray: this._fb.array([
        this._fb.group({
          expressionArray: this._fb.array([
            this._fb.group({
              condition: this._fb.control('', Validators.required),
              rule: this._fb.control(
                this.rules.length ? this.rules[0].rulename : '',
                Validators.required
              ),
            }),
          ]),
          groupOperator: this._fb.control('', Validators.required),
        }),
      ]),
    });
    this.expressionBuilderForm.valueChanges.subscribe({
      next: (item: any) => { 
        this.buildFinalExpression()
        if(!this.validateExpressionBuilderForm()){
          this.invalidExpression = "Please fill all the fields in the form";
        }
        else{
          this.invalidExpression = "";
        }
      }
    });
  }

  get isRemoveDisabled(): boolean {
    return this.getExpressionGroupArray()?.length <= 1;
  }
  getExpressionGroupArray() {
    return this.expressionBuilderForm.get('expressionGroupArray') as FormArray;
  }
  getExpressionArray(expressionGroup: any) {
    return expressionGroup.get('expressionArray') as FormArray;
  }
  addExpression(expressionGroupIndex: number) {
    const expressionGroup = (
      this.expressionBuilderForm.get('expressionGroupArray') as FormArray
    ).at(expressionGroupIndex);
    const expressions = expressionGroup.get('expressionArray') as FormArray;
    expressions.push(this._addExpression());
  }

  _addExpression() {
    return this._fb.group({
      condition: this._fb.control('', Validators.required),
      rule: this._fb.control('', Validators.required),
    });
  }

  onClickAddGroup() {
    const expressionGroups = this.expressionBuilderForm.get(
      'expressionGroupArray'
    ) as FormArray;
    expressionGroups.push(this._addGroup());
  }

  onClickRemoveGroup(expressionGroupIndex: number) {
    const expressionGroups = this.expressionBuilderForm.get(
      'expressionGroupArray'
    ) as FormArray;
    expressionGroups.removeAt(expressionGroupIndex);
  }

  _addGroup() {
    return this._fb.group({
      expressionArray: this._fb.array([this._addExpression()]),
      groupOperator: this._fb.control('',Validators.required),
    });
  }
  removeAnExpresion(expressionIndex: number, expressionGroupIndex: number) {
    const expressionsOfAGroup = (
      this.expressionBuilderForm.get('expressionGroupArray') as FormArray
    ).at(expressionGroupIndex);
    (expressionsOfAGroup.get('expressionArray') as FormArray).removeAt(
      expressionIndex
    );
  }

  buildFinalExpression() {
    const formJson = this.expressionBuilderForm.value['expressionGroupArray'];
    let finalstr = formJson
      .map((group: any, index: any) => {
        let innerExpression = group.expressionArray
          .map(
            (exp: any) =>
              `${exp.condition ? exp.condition + ' ' : ''}${exp.rule}`
          )
          .join(' ');
        // Wrap the inner expression in parentheses
        return `(${innerExpression.trim()})${
          index < formJson.length - 1 && group.groupOperator
            ? ` ${group.groupOperator}`
            : ''
        }`;
      })
      .join(' ');
    this.finalExpression = finalstr;
  }
  onClickSubmitExpression() {  
    let isValid = this.validateExpressionBuilderForm();
    if (isValid) {
      this._ruleEngineService.holdTheBuildExpressionData =
      this.expressionBuilderForm.value;
      this._ruleEngineService.setFinalRuleExpression(this.finalExpression);
      this._ruleEngineService.setPopUpValueForExpressionBuilder(false);
      //let result = this.getAllRulesAsRuleExpresions();
      // let ruleExpressions: RuleExpressoins = {
      //   rules: result,
      //   ruleSatisfaction: this.finalExpression,
      // };
      this.dialogRef.close();
      this.toastr.success("Rule expression updated", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });
    }
    else{
      this.invalidExpression = "Please fill all the fields in the form";
      this.toastr.warning("Please fill the required fileds", "", {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      });}
    }

  validateExpressionBuilderForm(): boolean {
    // Get the expressionGroupArray from the form
    const expressionGroupArray = this.expressionBuilderForm.get(
      'expressionGroupArray'
    ) as FormArray;

    let isValid = true; // Flag to track overall validity

    // Traverse each group in the expressionGroupArray
    for (let i = 0; i < expressionGroupArray.length; i++) {
      const group = expressionGroupArray.at(i) as FormGroup;

      // Get the expressionArray from the current group
      const expressionArray = group.get('expressionArray') as FormArray;

      // Traverse each expression in the expressionArray
      for (let j = 0; j < expressionArray.length; j++) {
        const expression = expressionArray.at(j) as FormGroup;

        // Get condition and rule from the current expression
        const condition = expression.get('condition');
        const rule = expression.get('rule');

        // Skip validation only for the first condition
        if (j === 0 && condition) {
          condition.markAsTouched(); // Mark condition as touched, but skip validation
        } else {
          // Validate all other conditions
          if (condition) {
            condition.markAsTouched(); // Mark condition as touched
            if (condition.invalid) {
              isValid = false; // If invalid, set flag to false
            }
          }
        }

        // Validate the rule field for all expressions
        if (rule) {
          rule.markAsTouched(); // Mark rule as touched
          const ruleValue = rule.value;
          const isRuleValid = this.rules.some(r => r.rulename === ruleValue);
          
          if (!isRuleValid) {
            rule.setErrors({ required: true }); // ❗️ Marks as invalid (same as required)
            isValid = false;
          } else {
            rule.setErrors(null); // Clears the error if valid
          }
          if (rule.invalid) {
            isValid = false; // If invalid, set flag to false
          }
        }
      }

      // Validate groupOperator
      const groupOperator = group.get('groupOperator');
      if (groupOperator) {
        groupOperator.markAsTouched(); // Mark groupOperator as touched
        if (i !== expressionGroupArray.length - 1) {
          // Validate groupOperator for all groups except the last one
          if (groupOperator.invalid) {
            isValid = false; // If invalid, set flag to false
          }
        }
      }
    }
    // Return overall validity
    return isValid;
  }

  getAllRulesAsRuleExpresions(): RuleExpression[] {
    let ruleExpressions: RuleExpression[] = this.rules.map((rule: Rule) => {
      let ruleExpression: RuleExpression = {
        rulenumber: rule.rulenumber,
        field: rule.field,
        operation: rule.operator,
        delimiter: '|',
        value: rule.value,
        rulename: rule.rulename
      };
      return ruleExpression;
    });
    return ruleExpressions;
  }

  // Method to load stored data into the form
  loadFormData(storedData: any) {
    const expressionGroupArray = this.expressionBuilderForm.get(
      'expressionGroupArray'
    ) as FormArray;

    if (storedData?.expressionGroupArray) {
      storedData.expressionGroupArray.forEach(
        (groupData: any, index: number) => {
          // Ensure that the FormArray has enough groups
          if (expressionGroupArray.length <= index) {
            expressionGroupArray.push(this._addGroup()); // Add new group if not enough
          }

          // Get the FormGroup from the FormArray
          const expressionGroup = expressionGroupArray.at(index) as FormGroup;

          // Patch expressionArray (nested FormArray) if it exists in the data
          if (groupData?.expressionArray) {
            this.patchExpressionArray(
              expressionGroup.get('expressionArray') as FormArray,
              groupData.expressionArray
            );
          }

          // Patch other fields of the group (like groupOperator)
          expressionGroup.patchValue({
            groupOperator: groupData.groupOperator,
          });
        }
      );
    }
  }

  // Helper method to patch FormArray data
  patchExpressionArray(expressionArray: FormArray, expressionArrayData: any[]) {
    // Clear current form array
    while (expressionArray.length) {
      expressionArray.removeAt(0);
    }

    // Add new controls based on the data
    expressionArrayData.forEach((data: any) => {
      const group = this._fb.group({
        condition: [data.condition, Validators.required],
        rule: [data.rule, Validators.required],
      });

      expressionArray.push(group);
    });
  }

  filterRules(value: string): Rule[] {
    const filterValue = value.toLowerCase();
    return this.rules.filter(rule => 
      rule.rulename.toLowerCase().includes(filterValue)
    );
  }
}
